import { createContext, useContext } from 'react'

export const MembershipProfileContext = createContext<{ id: number }>({ id: 0 })
export const useMembershipProfileContext = () =>
  useContext(MembershipProfileContext)
